export default {
  user: {},
  device: {},
};



// WEBPACK FOOTER //
// ./src/app/auth/store/state.js